import { IncidentNature, InstanceType } from '@app/shared/enums';

export class PeFormInstanceFormSummaryApiModel {
  public Date: Date;
  public FormInstanceId: number;
  public FormInstanceName: string;
  public FormInstanceNumber: string;
  public IncidentTypeName: string;
  public Nature: IncidentNature;
  public CompletedBy: string;
  public CurrentStepName: string;
  public InstanceType: InstanceType;
  public IsViewable: boolean;

  public fullName: string;

  public deserialize(data: Object): PeFormInstanceFormSummaryApiModel {
    Object.assign(this, data);

    this.Date = new Date(this.Date);
    this.fullName = this.FormInstanceNumber
      ? `${this.FormInstanceName}#${this.FormInstanceNumber}`
      : this.FormInstanceName;

    return this;
  }
}
